import { Link } from "react-router-dom";
import { defaultProductImage, PRODUCT_NOT_FOUND } from "../utils/Constants";
import { FaCartPlus } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as cartActions from "../store/action/cart";
import { toastMessage } from "../utils/Message";
import { useCartFetch } from "../hooks/useCartFetch";
import BtnLoader from "./BtnLoader";
import CityModal from "./modal/CityModal";
import { throttle } from "lodash";

function SellerProductCard({
  sellerProductsList,
  loadMoreProducts,
  hasMore,
  isLoading,
}) {
  const dispatch = useDispatch();

  const [isLoader, setIsLoader] = useState(0);
  const [cityModal, setCityModal] = useState(false);
  const [showClose, setShowClose] = useState(false);

  const { sellerPagination, cartSeller } = useSelector(
    (state) => state.product
  );
  const { storeCity } = useSelector((state) => state.auth);

  useCartFetch(storeCity);

  useEffect(() => {
    const handleScroll = throttle(() => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
          document.documentElement.offsetHeight - 500 &&
        !isLoading &&
        hasMore
      ) {
        loadMoreProducts();
      }
    }, 300);

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isLoading, hasMore, loadMoreProducts]);

  const cartAdd = async (product_id, seller_id, isVariant, slug) => {
    if (!storeCity) {
      setCityModal(true);
      return false;
    }

    setIsLoader(product_id);
    try {
      await dispatch(cartActions.cartAdd(product_id, seller_id, "", ""));
      await dispatch(cartActions.cartCount());
      await dispatch(cartActions.cartList(storeCity));
      setIsLoader(0);
      toastMessage(
        "Product successfully added to cart",
        "success",
        "top-center",
        2000
      );
    } catch (e) {
      toastMessage(e.message, "danger", "top-center", 5000);
      setIsLoader(0);
    }
  };

  if (isLoading && sellerProductsList.length === 0) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (sellerProductsList.length === 0 && !isLoading) {
    return (
      <div className="text-center py-5">
        <img
          src={PRODUCT_NOT_FOUND}
          alt="No products found"
          className="img-fluid"
          style={{ maxHeight: "300px", borderRadius: "50%" }}
        />
        <h5 className="mt-3 text-muted">No products found</h5>
        <p>Try adjusting your search or filters</p>
      </div>
    );
  }

  return (
    <>
      <CityModal
        cityModal={cityModal}
        setCityModal={setCityModal}
        showClose={showClose}
      />
      <div className="row">
        <div className={"d-flex justify-content-between align-items-center"}>
          <h6 style={{ fontSize: 20 }} className={"text-success"}>
            {cartSeller?.name} ({cartSeller?.username})
          </h6>
          <h6 className="text-danger" style={{ fontSize: 16 }}>
            The minimum order amount is {cartSeller?.minOrderAmount}
          </h6>
        </div>
        <h6 style={{ fontSize: 16 }}>
          Total Products : {sellerPagination.totalItems}
        </h6>
        {sellerProductsList.map((proData, index) => (
          <div
            className="col-6 col-sm-4 col-md-3 col-lg-2 col-xl-2 d-flex align-items-stretch"
            style={{ marginTop: index === 0 ? 0 : 10 }}
            key={proData.id}>
            <div className="card h-100 w-100">
              <div
                className="card-img-container position-relative"
                style={{
                  height: window.innerWidth < 576 ? "150px" : "180px",
                }}>
                <Link
                  to={`/product-details/${proData.product_slug}?product_id=${proData.id}`}
                  className="d-flex h-100 bg-light align-items-center justify-content-center">
                  <img
                    src={proData.image || defaultProductImage}
                    alt={proData.name}
                    className="img-fluid mh-100 mw-100 p-2"
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                    onError={(e) => {
                      e.target.src = defaultProductImage;
                    }}
                  />
                </Link>
                {proData.discount > 0 && (
                  <span className="badge bg-danger position-absolute top-0 start-0 m-2">
                    {proData.discount}% OFF
                  </span>
                )}
              </div>

              <div
                className="card-body d-flex flex-column"
                style={{ minHeight: "160px" }}>
                <div className="small mb-1 codeandmoq">
                  <span className="text-muted text-sm">
                    #{proData.product_code}
                  </span>

                  <span className="badge bg-warning text-dark text-sm moq">
                    MOQ: {proData.min_sale_qty}
                  </span>
                </div>

                <h6
                  className="card-title mb-2 fs-6 text-truncate-2 flex-grow-0"
                  title={proData.name}>
                  <Link
                    to={`/product-details/${proData.product_slug}?product_id=${proData.id}`}
                    className="text-dark text-decoration-none">
                    {proData.name}
                  </Link>
                </h6>

                <div className="price-container mb-2 flex-grow-0">
                  <div className="text-center">
                    <span className="text-gray-400 text-sm fw-semibold text-decoration-line-through d-block">
                      MRP : {proData.mrp}
                    </span>
                    <span className="text-heading text-md fw-semibold">
                      Rs. {Number(proData?.sellingPrice || 0).toFixed(2)}{" "}
                      <span className="text-gray-500 fw-normal">/Per Pc</span>{" "}
                    </span>
                  </div>
                </div>

                {proData.stock_status === "AVAILABLE" ? (
                  <button
                    className={`btn btn-sm mt-auto w-100 ${
                      isLoader === proData.id ? "btn-secondary" : "btn-success"
                    }`}
                    disabled={isLoader === proData.id}
                    onClick={() =>
                      cartAdd(
                        proData.id,
                        proData.seller,
                        proData.isVariant,
                        proData.product_slug
                      )
                    }
                    style={{
                      whiteSpace: "nowrap",
                      padding: "0.25rem 0.5rem",
                      fontSize: "0.875rem",
                    }}>
                    {isLoader === proData.id ? (
                      <BtnLoader />
                    ) : (
                      <>
                        <FaCartPlus className="me-1" /> Add to Cart
                      </>
                    )}
                  </button>
                ) : (
                  <button
                    className="btn btn-sm btn-danger w-100 mt-auto"
                    disabled>
                    Out of Stock
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {isLoading && sellerProductsList.length > 0 && (
        <div className="d-flex justify-content-center my-3">
          <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <style jsx>{`
        .card {
          transition: all 0.3s ease;
          border: 1px solid #eee;
          border-radius: 8px;
          overflow: hidden;
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
        }

        .card-img-container {
          height: 180px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8f9fa;
        }

        .text-truncate-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          min-height: 2.5em;
          line-height: 1.25;
          height: 2.5em;
        }

        .price-container {
          min-height: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .codeandmoq {
          display: flex;
          justify-content: space-between;
        }

        /* Mobile-specific styles */
        @media (max-width: 576px) {
          .card-img-container {
            height: 140px;
          }

          .moq {
            width: 100% !important;
            align-self: center;
          }

          .codeandmoq {
            display: inline;
          }

          .card-body {
            min-height: auto !important;
            padding: 0.75rem !important;
          }

          .text-truncate-2 {
            font-size: 0.775rem !important;
            min-height: 2.5em !important;
          }

          .price-container {
            min-height: auto !important;
          }

          .price-container span {
            font-size: 0.8rem;
          }

          .badge {
            font-size: 0.7rem;
            padding: 0.25em 0.4em;
          }
        }
      `}</style>
    </>
  );
}

export default SellerProductCard;
